import { useTranslate } from '@festina-life/ui/hooks'
import { useMemo } from 'react'

import type { SearchCategoryKey } from './types'

export const useCategoryTranslations = (): Record<
  SearchCategoryKey,
  string
> => {
  const translate = useTranslate()

  return useMemo(
    () => ({
      itemId: translate('search.category.itemId'),
      properties: translate('search.category.properties'),
      fplus: translate('search.category.fplus'),
      class: translate('search.category.class'),
      all: translate('search.category.all'),
    }),
    [translate],
  )
}
